import { Flex, Button, ButtonText, Icon, Checkbox, MarkdownPreview, Typography } from '@percent/lemonade';
import { StepProps } from './Step.types';
import styles from './Step.module.scss';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import { ErrorAlert } from '../ErrorAlert/ErrorAlert';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { PRIVACY_POLICY_URL } from '@percent/grants-nomination-form/constants/legalUrls';

export const Step = ({
  title,
  description,
  descriptionAlignment = 'center',
  additionalDescription,
  onBack,
  onNext,
  nextButtonLabel,
  nextButtonDisabled,
  isLoading,
  errorMessage,
  children,
  progress,
  withTermsCheckbox = false,
}: StepProps) => {
  const [termsAccepted, setTermsAccepted] = useState(false);

  return (
    <>
      {onBack && (
        <ButtonText
          variant="primary"
          size="sm"
          onClick={onBack}
          className={styles.backButton}
          data-testid="step-back-button"
        >
          <Icon name="arrow-left" size="m" />
        </ButtonText>
      )}
      <ProgressBar progress={progress} />
      <ErrorAlert message={errorMessage} />
      <Flex className={styles.step} key={description}>
        <Typography variant="h2" className={styles.title}>
          {title}
        </Typography>
        <MarkdownPreview content={description} className={styles[descriptionAlignment]} />
        {additionalDescription && (
          <Typography
            variant="large-bold"
            className={styles.additionalDescription}
            data-testid="step-additional-description"
          >
            {additionalDescription}
          </Typography>
        )}
        {children}
        {withTermsCheckbox && (
          <Flex className={styles.termsCheckbox}>
            <Checkbox
              name="termsAccepted"
              label={
                <Trans
                  i18nKey="typography.termsCheckbox"
                  components={{
                    a: (
                      // eslint-disable-next-line jsx-a11y/anchor-has-content
                      <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className={styles.link} />
                    ),
                  }}
                />
              }
              variant="default"
              active={termsAccepted}
              onChange={() => setTermsAccepted(!termsAccepted)}
            />
          </Flex>
        )}
        {onNext && (
          <div className={styles.buttonWrapper}>
            <Button
              onClick={onNext}
              data-testid="step-next-button"
              loading={isLoading}
              stretch
              disabled={isLoading || nextButtonDisabled || (withTermsCheckbox && !termsAccepted)}
            >
              {nextButtonLabel}
            </Button>
          </div>
        )}
      </Flex>
    </>
  );
};
